export default "__VITE_ASSET__B1HmNA8M__"